import React from 'react'
import { useTranslation } from 'react-i18next'
import QRCode from 'react-qr-code'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'

import type { SetupOtpMode } from './setup-otp'

type Props = {
  otpUrl: string
  onModeChange: (mode: SetupOtpMode) => void
}

export const SetupOtpQr: React.FC<Props> = ({ otpUrl, onModeChange }) => {
  const { t } = useTranslation()

  return (
    <Root>
      <Note>{t('mfa.setup_authenticator_note')}</Note>
      <QrContainer>
        <QRCode size={172} value={otpUrl} />
      </QrContainer>
      <CloseButton
        onClick={() => onModeChange('instructions')}
        variant="soft"
        size="xs"
      >
        {t('common.close')}
      </CloseButton>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  place-items: center;
  gap: 16px;
`

const QrContainer = styled.div`
  background: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 218px;
  width: 218px;
  border-radius: 22px;
`

const CloseButton = styled(Button)`
  padding-inline: 20px;
  margin-top: 10px;
`

const Note = styled.p`
  color: var(--text-11);
  font-size: 12px;
  text-align: center;
  margin-bottom: 10px;
  line-height: 16px;
`
